import React, { Suspense } from 'react';

import { withWebinarPlayerContext } from '$/components/WebinarPlayer/context';

const TestControlBarButtons = React.lazy(() => import('./TestControlBarButtons'));

export const TestControlBar: React.FC = withWebinarPlayerContext(['inTestMode'])(({ context }) => {
  const { inTestMode } = context;

  if (!inTestMode) {
    return null;
  }

  return (
    <Suspense>
      <TestControlBarButtons />
    </Suspense>
  );
});
